/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAnnouncementDto } from '../../models/platform-api-result-of-announcement-dto';

export interface GetNotificationsAnnouncementsId$Params {
  Id: string;
}

export function getNotificationsAnnouncementsId(http: HttpClient, rootUrl: string, params: GetNotificationsAnnouncementsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
  const rb = new RequestBuilder(rootUrl, getNotificationsAnnouncementsId.PATH, 'get');
  if (params) {
    rb.path('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAnnouncementDto>;
    })
  );
}

getNotificationsAnnouncementsId.PATH = '/api/notifications/announcements/{id}';
